export default {
  country_locale: 'it-IT',
  wia_contact_links: {
    HP: 'https://www.hotpoint.it/Pagine/Condizioni-generali-di-acquisto-online',
    ID: 'https://www.indesit.it/Assistenza/Servizio-Clienti#contact_form',
    WP: 'https://www.whirlpool.it/contattaci/'
  },
  wia_title: 'Iniziamo dal prodotto:',
  wia_need_help: 'Hai bisogno di aiuto con',
  wia_model_name: 'Il nome del prodotto è',
  wia_back: '< cambia',
  wia_confirm: 'Invia',
  wia_issue_search: 'Qual è il problema ?',
  wia_issue_description: 'Descrivi sinteticamente il principale problema del tuo apparecchio',
  wia_issue_placeholder: 'Es: perde acqua da sotto',
  wia_issue_generic_macro_category: 'Generali',
  wia_issue_no_results: 'Nessun risultato trovato!',
  wia_issue_search_label: 'Cerca',
  wia_issue_title: 'Ricerca manuale',
  wia_issue_concern: 'Quale problema hai riscontrato ?',
  wia_issue_specific: 'Qualche dettaglio in più',
  wia_possible_solution: 'Possibili soluzioni',
  wia_related_solution: 'Soluzioni correlate',
  wia_solved_issue: 'Risolto il problema ?',
  wia_closed: 'Chiudi X',
  wia_feedback_ok: ' Si !',
  wia_find_another_solution: 'Prova altre soluzioni.',
  wia_feedback_title: 'Siamo contenti che il tuo problema si sia risolto!',
  wia_feedback_text1: 'Visita il nostro shop e scopri le offerte speciali a te dedicate',
  wia_feedback_text2: '',
  wia_smile_up_popup_text1: 'Scopri i nostri piani di protezione',
  wia_smile_down_popup_title: 'Hai ancora bisogno di aiuto ?',
  wia_smile_down_popup_text1: 'Vai al secondo step',
  wia_smile_down_popup_or_text: 'oppure',
  wia_smile_down_popup_text2: 'Prenota un intervento',
  wia_need_more_help: 'Hai ancora bisogno di aiuto ?',
  wia_optional_label: '(opzionale)',
  wia_no_solution: 'Non siamo riusciti a trovare una semplice soluzione per il tuo problema, ma non ti preoccupare siamo qui per aiutarti. Per favore clicca qui per avere supporto.',
  wia_all_solution: 'Tutti i risultati',
  wia_all_categories: 'Tutte le categorie',
  wia_seo_l1_issue: 'Tutti i guasti per categoria',
  wia_seo_wp_country_name: 'Italia',
  wia_seo_bk_country_name: '',
  wia_seo_hp_country_name: 'IT',
  wia_seo_id_country_name: 'IT',
  wia_seo_wp_meta_title: 'Problemi e Soluzioni',
  wia_seo_bk_meta_title: 'Problemi e Soluzioni',
  wia_seo_hp_meta_title: 'Problemi e Soluzioni',
  wia_seo_id_meta_title: 'Problemi e Soluzioni',
  wia_seo_wp_meta_description: 'risolvi in pochi click i problemi legati ai tuoi elettrodomestici con l’assistenza tecnica online di European Appliances Italy SRL',
  wia_seo_bk_meta_description: 'risolvi in pochi click i problemi legati ai tuoi elettrodomestici con l’assistenza tecnica online di Bauknecht Italia',
  wia_seo_hp_meta_description: 'risolvi in pochi click i problemi legati ai tuoi elettrodomestici con l’assistenza tecnica online di Hotpoint Italia',
  wia_seo_id_meta_description: 'risolvi in pochi click i problemi legati ai tuoi elettrodomestici con l’assistenza tecnica online di Indesit Italia',
  wia_seo_wp_meta_description_home: '',
  wia_seo_bk_meta_description_home: '',
  wia_seo_hp_meta_description_home: '',
  wia_seo_id_meta_description_home: ''
}
